var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 11.9994L11.9995 20.9994C11.2039 20.9994 10.4408 20.6833 9.87822 20.1207C9.31561 19.5581 8.99954 18.795 8.99954 17.9994V13.9994H3.33954C3.04963 14.0027 2.76248 13.9429 2.49797 13.8242C2.23346 13.7055 1.99793 13.5307 1.80768 13.3119C1.61744 13.0931 1.47704 12.8356 1.3962 12.5571C1.31537 12.2787 1.29603 11.986 1.33954 11.6994L2.71954 2.69938C2.79187 2.22248 3.03411 1.78778 3.40164 1.47538C3.76916 1.16298 4.23721 0.993932 4.71954 0.999385H15.9995M15.9995 11.9994V0.999385M15.9995 11.9994H18.6695C19.2355 12.0094 19.7854 11.8112 20.215 11.4426C20.6445 11.0739 20.9237 10.5603 20.9995 9.99938V2.99938C20.9237 2.43844 20.6445 1.92489 20.215 1.5562C19.7854 1.18752 19.2355 0.989376 18.6695 0.999385H15.9995",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumbDown.8f84ee48ba7a7a7d0e2b589035ecd351.svg";
export { ForwardRef as ReactComponent };